export default function Toast({ toast }) {

    if (!toast) return null;

    return (
        <div className={`fixed bottom-6 left-6 px-4 py-2 rounded shadow ${
            toast.type === "success"
                ? "bg-green-600 text-white"
                : "bg-red-600 text-white"
        }`}>
            {toast.message}
        </div>
    );
}
